import React, { useRef, useEffect } from "react";
import { amountToWords } from "../../../amountToWords";
import { useReactToPrint } from "react-to-print";

// npm install react-to-print

const Print_Receipt = ({ schoolDetails, headerData, detailRows, onAfterPrint }) => {

  const printRef = useRef();


  const handlePrint = useReactToPrint({
    //content: () => printRef.current,
    contentRef: printRef,

    pageStyle: `
    @page {
      size: A4;
      margin: 12mm;
    }

    @media print {
      html,
      body {
        margin: 0;
        padding: 0;
      }

      #voucher-print-area {
        box-sizing: border-box;
        width: 100%;
      }
    }
  `,

    onAfterPrint: () => {
      if (onAfterPrint) {
        onAfterPrint();
      }
    },

    // onAfterPrint: () => {
    //   onAfterPrint?.();
    // },

  });

  // useEffect(() => {
  //   if (showPrintReady()) {
  //     const timer = setTimeout(() => {
  //       handlePrint();
  //     }, 200);

  //     return () => clearTimeout(timer);
  //   }
  // }, [schoolDetails, detailRows]);

  const showPrintReady = () => {
    return (
      schoolDetails?.schoolName &&
      detailRows &&
      detailRows.length > 0
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const paymentModeMap = {
    CASH: "Cash",
    CHQ: "Cheque",
    ADJ: "Adjustment",
    OL: "Online",
    OTH: "Others",
  };

  const receipt = {

    company: schoolDetails.schoolName,
    address: schoolDetails.schoolAddr1 || ' ' || schoolDetails.schoolAddr1,
    phone: schoolDetails.schoolPhone1,
    logo_path: schoolDetails.logoPath,
    logo_name: 'school_logo.png',
    preparedBy: schoolDetails.preparedBy,
    receiptNo: headerData.receipt_no,
    year1: headerData.year1,
    year2: headerData.year2,
    date: formatDate(headerData.receipt_date),
    grNo: headerData.gr_no,
    stud_name: headerData.stud_name,
    std_div: headerData.std_name || '/' || headerData.div_name,
    fromInst: headerData.from_install_name,
    toInst: headerData.to_install_name,
    amount: headerData.total_fees,
    paymentMode: paymentModeMap[headerData.payment_mode] || headerData.payment_mode,
    instrumentNo: headerData.instrument_no,

  };


  const parseAmount = v => Number(String(v).replace(/,/g, "") || 0);

  const totalAmount = detailRows.reduce(
    (sum, r) => sum + parseAmount(r.net_amt),
    0
  );

  const formatAmount = (amount) =>
    Number(amount || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "40px" }}>
      {/* <div style={{ fontFamily: "courier", padding: "20px" }}> */}
      {/* 🔹 Print button (not included in print area) */}
      <button
        onClick={handlePrint}
        style={{
          marginBottom: "20px",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        🖨️ Print Receipt
      </button>

      {/* 🔹 Receipt content to be printed */}
      {/* <div ref={printRef} id="receipt-print-area" style={{ border: "2px solid #000", padding: "10px", borderRadius: "4px" }}> */}

        <div ref={printRef} id="receipt-print-area" 
           style={{ border: "4px double #000", padding: "12px", minHeight: "225mm",      // Fill printable area
                     boxSizing: "border-box", background: "#fff", }} >

        {/* HEADER */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", paddingBottom: "5px" }} >

          {/* Logo Left */}
          {receipt.logo_path && (
            <img src={`${receipt.logo_path}${receipt.logo_name}`} alt="School Logo"
              style={{ width: "70px", height: "70px", objectFit: "contain", position: "absolute", left: 0, top: 0, }}
              onError={(e) => { e.target.style.display = "none"; }}
            />
          )}

          {/* Company Details */}
          <div style={{ textAlign: "center" }}>
            <h5 style={{ margin: 0 }}> <b> {receipt.company}</b> </h5>
            <p style={{ margin: "2px 0", fontSize: "15px", }}> {receipt.address}</p>
            {/* <p style={{ margin: "2px 0", fontSize: "15px", }}> Phone: {receipt.phone}</p> */}
            <p style={{ margin: "2px 0", fontSize: "15px", }}> <b> FEE RECEIPT ({receipt.year1}-{receipt.year2}) </b> </p>
          </div>

          {/* <div style={{ textAlign: "center" }}>
             <h5 style={{ margin: 0 }}>FEE RECEIPT</h5>
          </div> */}

        </div>

        <hr style={{ border: "1px solid #000", margin: "5px 0 10px 0" }} />

        <table style={{ width: "100%", marginTop: "10px", maxHeight: '35px', borderCollapse: "collapse", border: "none" }}>
          <tbody>
            <tr>
              <td style={{ width: "65%", padding: "3px", border: "none", fontSize: "15px" }}> 
                <strong>Receipt No. :</strong> {receipt.receiptNo} </td>
              <td style={{ width: "35%", padding: "3px", border: "none", fontSize: "15px" }}>
                 <strong>Date :</strong> {receipt.date} </td>
            </tr>
            <tr>
              <td style={{ width: "65%", padding: "3px", border: "none", fontSize: "15px" }}>
                <strong>Student Name :</strong> {receipt.stud_name.replace(/^\d+\s*/, "")}</td>
              <td style={{ width: "35%", padding: "3px", border: "none", fontSize: "15px" }}>
                <strong>GR No. :</strong> {receipt.grNo}</td>
            </tr>
            <tr>
              <td style={{ width: "65%", padding: "3px", border: "none", fontSize: "15px" }}>
                 <strong>Std/Div :</strong> {receipt.std_div}</td>
              <td style={{ width: "35%", padding: "3px", border: "none", fontSize: "15px" }}>
                 <strong>Amount Paid :</strong> &nbsp;&nbsp;
               ₹  {receipt.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })} 
              </td>
            </tr>
            <tr>
              <td style={{ width: "100%", padding: "3px", border: "none", fontSize: "15px" }} colSpan={4}>
                   <strong>Period :</strong> {receipt.fromInst} <b> To </b>{receipt.toInst}</td>
              {/* <td style={{ width: "35%", padding: "3px", border: "none", fontSize: "15px" }} >
                <strong>Waiver Amount :</strong> {receipt.narration}</td> */}
            </tr>
            <tr>
              <td style={{ width: "65%", padding: "3px", border: "none", fontSize: "15px" }}>
                 <strong>Payment Mode :</strong> {receipt.paymentMode}</td>
              <td style={{ width: "35%", padding: "3px", border: "none", fontSize: "15px" }}>
                 <strong>Chq No. :</strong> {receipt.instrumentNo} 
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
            maxHeight: '35px'
          }}
        >
          <thead>
            <tr>
              <th style={{
                width: "3%", border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000", textAlign: 'center'
              }}>Sr. #</th>

              <th style={{
                width: '30%', textAlign: 'left', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000"
              }}>Fee Components</th>
              <th style={{
                width: '12%', textAlign: 'right', border: "1px solid #000", padding: "4px",
                backgroundColor: "white", color: "#000"
              }}>Amount (₹)</th>
            </tr>
          </thead>

          <tbody>
            {detailRows && detailRows.length > 0 ? (
              detailRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "center", fontSize: "14px" }}> {index + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", fontSize: "14px" }}>{row.fee_desc}</td>
                  <td style={{ border: "1px solid #000", padding: "3px", textAlign: "right", fontSize: "14px" }}> 
                    {formatAmount(row.net_amt)} 
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="3"
                  style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}
                >
                  No Data Available
                </td>
              </tr>
            )}

            {/* 🔹 TOTAL ROW */}
            <tr>
              <td
                colSpan="2"
                style={{ border: "1px solid #000", padding: "4px", textAlign: "left", fontSize: "15px" }}
              >
                <strong>Total</strong>
              </td>

              <td style={{ border: "1px solid #000", padding: "4px", textAlign: "right", fontSize: "15px" }}
              >
                <strong>
                  {totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </strong>
              </td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: "10px", fontSize: "15px" }}>
          <strong>Amount in Words: </strong>
          <span>{amountToWords(totalAmount)}</span>
        </p>

        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ fontSize: "15px" }}><u>&nbsp;{receipt.preparedBy}&nbsp;</u><br />Prepared By</div>
          {/* <div style={{ fontSize: "15px" }}>_________________<br />Authorized By</div>
          <div style={{ fontSize: "15px" }}>_________________<br />Receiver’s Signature</div> */}
        </div>
      </div>
    </div>
  );
};

export default Print_Receipt;
